import keyMirror from 'keymirror'

export const TenantProjectTabs = {
  projectInfo: 0,
  submissions: 1,
  contractorInfo: 2,
  workPermit: 3,
  projectControl: 4,
}

export const TenantProjectActions = keyMirror({
  cancel: null,
  withdraw: null,
  complete: null,
  fileSubmitted: null,
})

/** @enum */
export const TAB_TYPE = keyMirror({
  FIT_OUT: null,
  POST_FIT_OUT: null,
  GREEN_FIT_OUT: null,
})

/** @enum */
export const DEPENDENCY_KEYS = {
  TAB_TYPE: Symbol('TAB_TYPE'),
  POSTFITOUT_ENTRY: Symbol('POSTFITOUT_ENTRY'),
  CURRENT_SUBMISSION: Symbol('CURRENT_SUBMISSION'),
}

export const FINAL_DOC_STATUS = keyMirror({
  DRAFT: null,
  EXEMPTED: null,
  COMPLETED: null,
  // HISTORICAL data doesn't apply complete or exempt workflow
  HISTORICAL: null,
  SEND_REMINDER: null,
})

export const FINAL_DOC_FOLDER_STATUS = keyMirror({
  DRAFT: null,
  ACCEPTED: null,
  REJECTED: null,
})

export const TP_LIFECYCLE_TYPE = keyMirror({
  REINSTATEMENT_LETTER_SENT: null,
})
